import { Pipe, PipeTransform } from '@angular/core';
import { OrderDto } from '../models/OrderDto';
import { OrderStatus } from '../pages/checkout-process/order-success/order-utils';

export interface PaidType{
  paymentMode: string;
  logs: any[];
  paymentId: string;
}
@Pipe({
  name: 'paid'
})
export class PaidPipe implements PipeTransform {

  transform( value: PaidType): any {   
    if(value.paymentMode== 'AMAZON') return true;
    if(value.paymentMode=='CASH') return true;
    if(value.paymentMode=='COD') return value.logs !=null && value.logs != undefined && value.logs.filter(l=> l.status == 'PAID').length !=0;
    if(value.paymentId!=null) return true;
    return false;
  }

}
